<!-- « À propos de Willy » (P5.1.1) : une feuille du bas comme les autres
     (poignée, titre, croix de 44 px), plus l'ancienne fenêtre centrée. -->
<vw-toast-popup [isOpen]="isOpen" [title]="'common.modals.ai-chatbot-info-modal.title' | translate" (close)="close()">
  <div class="flex flex-col gap-3 px-4 pb-6">
    <div class="flex items-start gap-3">
      <img src="/assets/images/willy/willy_hi.webp" alt="" class="h-12 w-12 shrink-0 rounded-pill bg-vw-surface-tint object-contain">
      <p class="text-body text-vw-body">{{ 'common.modals.ai-chatbot-info-modal.content' | translate }}</p>
    </div>
    <p class="text-body text-vw-body">{{ 'common.modals.ai-chatbot-info-modal.content2' | translate }}</p>
    <vw-button look="primary" customClass="w-full" class="mt-2 block" data-testid="willy-info-ok"
      [label]="'common.understood' | translate" (onClick)="close()"></vw-button>
  </div>
</vw-toast-popup>
